import Vue from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueDragscroll from 'vue-dragscroll/src/main'

Vue.use(VueDragscroll)
